// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__JlG4L","footer":"ModalFilter_footer__3ClbL"};